$(document).ready(function() {
	$(document).on('submit', ".gform_wrapper form", function(event) {
		$(".gform_button").prop('disabled', true).text("Processing, please wait...");
	});
});
